"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tests a condition.
 *
 * <pre>
 * {% if users %}
 *  <ul>
 *    {% for user in users %}
 *      <li>{{ user.username|e }}</li>
 *    {% endfor %}
 *  </ul>
 * {% endif %}
 * </pre>
 */
const token_parser_1 = require("../token-parser");
const node_1 = require("../node");
const token_1 = require("../token");
const if_1 = require("../node/if");
class TwingTokenParserIf extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let expr = this.parser.getExpressionParser().parseExpression();
        let stream = this.parser.getStream();
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let index = 0;
        let body = this.parser.subparse([this, this.decideIfFork]);
        let tests = new Map([
            [index++, expr],
            [index++, body]
        ]);
        let elseNode = null;
        let end = false;
        while (!end) {
            switch (stream.next().getValue()) {
                case 'else':
                    stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
                    elseNode = this.parser.subparse([this, this.decideIfEnd]);
                    break;
                case 'elseif':
                    expr = this.parser.getExpressionParser().parseExpression();
                    stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
                    body = this.parser.subparse([this, this.decideIfFork]);
                    tests.set(index++, expr);
                    tests.set(index++, body);
                    break;
                case 'endif':
                    end = true;
                    break;
            }
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new if_1.TwingNodeIf(new node_1.TwingNode(tests), elseNode, lineno, columnno, this.getTag());
    }
    decideIfFork(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, ['elseif', 'else', 'endif']);
    }
    decideIfEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endif');
    }
    getTag() {
        return 'if';
    }
}
exports.TwingTokenParserIf = TwingTokenParserIf;
